var _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ffffff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0608,
    cy: 10.1774,
    r: 7.17735,
    fill: "#B4B4C7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.94423,
    cy: 23.1774,
    r: 5.82265,
    fill: "#DFDDEA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.1774,
    cy: 23.1774,
    r: 5.82265,
    fill: "#DFDDEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTeam);
export default __webpack_public_path__ + "static/media/menu-team.29e3de51a2aad8ca01813c9a135c4d10.svg";
export { ForwardRef as ReactComponent };